<template>
  <div>
    <div class="row reports">
      <div class="col-lg-12 col-md-12">
        <vue-tabs
          class="row settings-tabs full-height-tabs"
          type="tabs"
          :value="selectedTab"
          direction="vertical"
          @tab-change="handleTabChange"
        >
          <!-- <v-tab title="Beta" class="text-left title" disabled></v-tab> -->

          <!-- Sales Report -->
          <v-tab :title="$t('reports.salesReport')">
            <reports-sales :isReports="isReports"></reports-sales>
          </v-tab>
          <!-- END Sales Report -->

          <!-- Sales Report BETA -->
          <v-tab :title="$t('reports.salesReportBeta')">
            <reports-sales-beta :isSalesReportBeta="isSalesReportBeta"></reports-sales-beta>
          </v-tab>
          <!-- END Sales Report BETA -->

          <v-tab :title="$t('reports.paymentTypes')">
            <sales-payment-method :isSalesPaymentMethod="isSalesPaymentMethod"></sales-payment-method>
          </v-tab>

          <v-tab :title="$t('reports.productsSalesReport2')">
            <sales-products :isSalesProducts="isSalesProducts"></sales-products>
          </v-tab>

          <v-tab :title="$t('reports.productSaleTrendsReport')">
            <sales-products-trend :isSalesProductsTrend="isSalesProductsTrend"></sales-products-trend>
          </v-tab>

          <v-tab :title="$t('reports.salesTrendsReport')">
            <sales-trend :isSalesTrend="isSalesTrend"></sales-trend>
          </v-tab>

          <v-tab :title="$t('reports.topProductsReport')">
            <top-products :isTopProducts="isTopProducts"></top-products>
          </v-tab>

          <v-tab :title="$t('reports.topCategoriesReport')">
            <top-categories :isTopCategories="isTopCategories"></top-categories>
          </v-tab>

          <v-tab :title="$t('reports.orderFromReport')">
            <order-from :isOrderFrom="isOrderFrom"></order-from>
          </v-tab>

          <v-tab :title="$t('reports.operatorSalesReport')">
            <operator-sales :isOperatorSales="isOperatorSales"></operator-sales>
          </v-tab>

          <v-tab :title="$t('reports.waiterTipsReport')">
            <waiter-tips-report :isWaiterTips="isWaiterTips"></waiter-tips-report>
          </v-tab>

          <v-tab :title="$t('reports.stornoReport')">
            <storno :isStorno="isStorno"></storno>
          </v-tab>

          <v-tab :title="$t('reports.dashboardReport')">
            <dashboard-report :isDashboardReport="isDashboardReport"></dashboard-report>
          </v-tab>

          <v-tab :title="$t('reports.productsAndOptionsReport')">
            <products-and-options-report :isProductsAndOptions="isProductsAndOptions"></products-and-options-report>
          </v-tab>

          <v-tab :title="$t('reports.preordersItems')">
            <preorders-items :isPreordersItems="isPreordersItems"></preorders-items>
          </v-tab>

          <v-tab :title="$t('reports.fiscalZReport')">
            <fiscal-z-report :isMasterReport="isFiscalZReport"></fiscal-z-report>
          </v-tab>

          <v-tab :title="$t('reports.mixReport')">
            <mixed-report :isMixedReport="isMixedReport"></mixed-report>
          </v-tab>

          <v-tab :title="$t('reports.posOrderActionsReport')">
            <pos-order-actions-report :isPosOrderActionsReport="isPosOrderActionsReport"></pos-order-actions-report>
          </v-tab>

          <v-tab :title="$t('reports.custom')" class="text-left title" disabled></v-tab>

          <v-tab :title="$t('reports.masterReport')">
            <master-report :isMasterReport="isMasterReport"></master-report>
          </v-tab>

          <v-tab :title="$t('reports.masterReportBeta')">
            <master-report :isMasterReport="isMasterReportBeta" :useFromColumns="true"></master-report>
          </v-tab>

          <v-tab :title="$t('reports.tableOpenOrders')">
            <table-open-order-report :isTableOpenOrderReport="isTableOpenOrderReport"></table-open-order-report>
          </v-tab>

          <v-tab :title="$t('reports.customerLifetimeValueReport')">
            <customer-lifetime-value :isCustomerLifetimeValueReport="isCustomerLifetimeValueReport"></customer-lifetime-value>
          </v-tab>

          <v-tab :title="$t('reports.labelEvolution')">
            <label-evolution :isLabelEvolution="isLabelEvolution"></label-evolution>
          </v-tab>

          <v-tab :title="$t('reports.donationCampaignsReport')" id="donationCampaignsReport">
            <donation-campaigns-report :isDonationCampaignsReport="isDonationCampaignsReport"></donation-campaigns-report>
          </v-tab>
          <v-tab :title="$t('reports.loyaltyStoreReport')" id="loyaltyStoreReport">
            <loyalty-store-report :isLoyaltyStoreReport="isLoyaltyStoreReport"></loyalty-store-report>
          </v-tab>
          <v-tab :title="$t('reports.challengeCampaignsReport')" id="challengeCampaignsReport">
            <challenge-campaigns-report :isChallengeCampaignsReport="isChallengeCampaignsReport"></challenge-campaigns-report>
          </v-tab>
          <v-tab :title="$t('reports.spinningWheelReport')" id="spinningWheelReport">
            <spinning-wheel-report :isSpinningWheelReport="isSpinningWheelReport"></spinning-wheel-report>
          </v-tab>
          <v-tab :title="$t('reports.referralProgramReport')">
            <referral-program-report :isReferralProgramReport="isReferralProgramReport"></referral-program-report>
          </v-tab>
          <v-tab :title="$t('reports.raffleCampaignsReport')">
            <raffle-campaigns-report :isRaffleCampaignsReport="isRaffleCampaignsReport"></raffle-campaigns-report>
          </v-tab>

          <v-tab :title="$t('reports.old')" class="text-left title" disabled></v-tab>

          <!-- Trends Reports Tab -->
          <v-tab :title="$t('reports.trends')">
            <trends :isTrends="isTrends"></trends>
          </v-tab>
          <!-- END Trends Reports Tab -->

          <!-- Sales Report -->
          <v-tab :title="$t('reports.accountingReport')">
            <accounting-report :isReports="isReports"></accounting-report>
          </v-tab>
          <!-- END Sales Report -->

          <!-- Clients Reports Tab -->
          <v-tab :title="$t('reports.clientsWOrders')">
            <clients :isClients="isClients"></clients>
          </v-tab>
          <!-- END Clients Reports Tab -->

          <!-- Products Sales Reports Tab -->
          <v-tab :title="$t('reports.productsSalesReport')">
            <products-sales :isProductSales="isProductSales"></products-sales>
          </v-tab>
          <!-- END Clients Reports Tab -->

          <!-- Order Status Reports Tab -->
          <v-tab :title="$t('reports.orderStatus')" id="orderStatus">
            <order-status :isOrderStatus="isOrderStatus"></order-status>
          </v-tab>
          <!-- END Order Status Tab -->

          <!-- Order Status Reports Tab -->
          <v-tab :title="$t('reports.pdfRaport')" id="pdfRaport">
            <pdf-raport :isPdfRaport="isPdfRaport"></pdf-raport>
          </v-tab>
          <!-- END Order Status Tab -->

          <!-- Order Status Reports Tab -->
          <v-tab :title="$t('reports.loyaltyPoints')" id="loyaltyPoints">
            <loyalty-points :isLoyaltyPoints="isLoyaltyPoints"></loyalty-points>
          </v-tab>
          <!-- END Order Status Tab -->

          <!-- Donation Report Tab -->
          <v-tab :title="$t('reports.donationReport')" id="donationReport">
            <donation-report :isDonationReport="isDonationReport"></donation-report>
          </v-tab>
          <!-- END Donation Report Tab -->

          <!-- Order Status Reports Tab -->
          <v-tab :title="$t('reports.ocr')" id="ocr">
            <ocr v-if="isOCR"></ocr>
          </v-tab>
          <!-- END Order Status Tab -->

          <!-- Stock Movements Report Tab -->
          <v-tab :title="$t('reports.stockMovements')" id="stockMovements">
            <stock-movements v-if="isStockMovements"></stock-movements>
          </v-tab>
          <!-- END Stock Movements Report Tab -->

          <!-- Reorder Popup Responses Report Tab -->
          <v-tab :title="$t('reports.reorderPopupResponses')" id="reorderPopupResponses">
            <reorder-popup-responses v-if="isReorderPopupResponses"></reorder-popup-responses>
          </v-tab>
          <!-- END Reorder Popup Responses Report Tab -->


          <!-- Order Status Reports Tab -->
          <v-tab :title="$t('reports.wallet')" id="wallet">
            <wallet v-if="isWallet"></wallet>
          </v-tab>
          <!-- END Order Status Tab -->

          <!-- Report Requests Reports Tab -->
          <v-tab :title="$t('reports.reportRequestTab')" id="reportRequest">
            <report-request ref="reportRequest" v-if="isReportRequest"></report-request>
          </v-tab>

          <!-- <v-tab :title="$t('reports.old')" class="text-left title" disabled></v-tab> -->
          <v-tab v-if="hasCharismaLocation" title="Charisma" class="text-left title" disabled></v-tab>

          <v-tab v-if="hasCharismaLocation" :title="$t('reports.charismaReport')" id="charismaReport">
            <charisma-report v-if="isCharismaReport" :isCharismaReport="isCharismaReport"></charisma-report>
          </v-tab>

          <v-tab v-if="hasCharismaLocation" :title="$t('reports.charismaLocationReceipt')" id="charismaLocationReceipt">
            <charisma-location-receipt
              v-if="isCharismaLocationReceiptReport"
              :isCharismaLocationReceiptReport="isCharismaLocationReceiptReport">
            </charisma-location-receipt>
          </v-tab>

          <v-tab v-if="hasNexusLocation" title="Nexus" class="text-left title" disabled></v-tab>

          <v-tab v-if="hasNexusLocation" :title="$t('reports.nexusReport')" id="nexusReport">
            <nexus-report v-if="isNexusReport" :isNexusReport="isNexusReport"></nexus-report>
          </v-tab>

          <!-- END Report Requests Tab -->

          <!-- Products Reports Tab -->
          <!-- <v-tab v-if="false" :title="$t('reports.products')" icon="icon-report icon-report-prod">
            <products></products>
          </v-tab> -->
          <!-- END Products Reports Tab -->

          <!-- Marketing Reports Tab -->
          <!-- <v-tab :title="$t('reports.marketing')" icon="icon-report icon-report-marketing">
            <marketing></marketing>
          </v-tab> -->
          <!-- END Marketing Reports Tab -->

          <!-- Client loyalty points -->
          <v-tab :title="$t('reports.clientLoyalty')" id="clientLoyalty" icon="icon-report icon-report-clients">
            <client-points :isClientPoints="isClientPoints"></client-points>
          </v-tab>
          <!-- END Client loyalty points -->
          <v-tab title="Rapoarte exportabile" class="text-left title" disabled></v-tab>
          <v-tab title="Export CSV" id="exportableReports">
            <exportable-reports v-if="isExportableReports" @show-requests="showReportRequests"></exportable-reports>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>

<script>

import Trends from './Trends.vue'
import ExportableReports from './ExportableReports.vue'
import ReportsSales from './ReportsSales.vue'
import ReportsSalesBeta from './ReportsSalesBeta.vue'
import AccountingReport from './AccountingReport.vue'
import Clients from './Clients.vue'
import ProductsSales from './ProductsSales.vue'
import OrderStatus from './OrderStatus.vue'
import PdfRaport from './PdfRaport.vue'
import LoyaltyPoints from './LoyaltyPoints.vue'
import ClientPoints from './ClientPoints.vue'
import DonationReport from './DonationReport.vue'
import DonationCampaignsReport from './DonationCampaignsReport.vue'
import RaffleCampaignsReport from './RaffleCampaignsReport.vue'
import LoyaltyStoreReport from './LoyaltyStoreReport.vue'
import ChallengeCampaignsReport from './ChallengeCampaignsReport.vue'
import SpinningWheelReport from './SpinningWheelReport.vue'
import Ocr from './Ocr.vue'
import StockMovements from './StockMovements.vue'
import ReorderPopupResponses from './ReorderPopupResponses.vue'
import Wallet from './Wallet.vue'
import ReportRequest from './ReportRequest.vue'
import SalesPaymentMethod from './Versions/2/SalesPaymentMethod.vue'
import SalesProducts from './Versions/2/SalesProducts.vue'
import SalesProductsTrend from './Versions/2/SalesProductsTrend.vue'
import SalesTrend from './Versions/2/SalesTrend.vue'
import TopProducts from './Versions/2/TopProducts.vue'
import TopCategories from './Versions/2/TopCategories.vue'
import OrderFrom from './Versions/2/OrderFromReport.vue'
import ProductsAndOptionsReport from './Versions/2/ProductsAndOptionsReport.vue'
import OperatorSales from './Versions/2/OperatorSalesReport.vue'
import WaiterTipsReport from './Versions/2/WaiterTipsReport.vue'
import DashboardReport from './Versions/2/DashboardReport.vue'
import Storno from './Versions/2/StornoReport.vue'
import MasterReport from './Versions/2/MasterReport.vue'
import FiscalZReport from './Versions/2/FiscalZReport.vue'
import TableOpenOrderReport from './Versions/2/TableOpenOrderReport.vue'
import PosOrderActionsReport from './Versions/2/PosOrderActionsReport.vue'
import CustomerLifetimeValue from './Versions/2/CustomerLifetimeValue.vue'
import ReferralProgramReport from './Versions/2/ReferralProgramReport.vue'
import PreordersItems from './Versions/2/PreordersItems.vue'
import MixedReport from './Versions/2/MixedReport.vue'
import CharismaReport from './Versions/2/CharismaReport.vue'
import CharismaLocationReceipt from './Versions/2/CharismaLocationReceipt.vue'
import NexusReport from './Versions/2/NexusReport.vue'
import LabelEvolution from './Versions/2/LabelEvolution.vue'
// import Products from './Products.vue'
// import Marketing from './Marketing.vue'
// import JsonExcel from 'vue-json-excel'
// Vue.use(JsonExcel)
export default {
  components: {
    Trends,
    ExportableReports,
    ReportsSales,
    ReportsSalesBeta,
    AccountingReport,
    Clients,
    ProductsSales,
    OrderStatus,
    PdfRaport,
    LoyaltyPoints,
    ClientPoints,
    DonationReport,
    DonationCampaignsReport,
    RaffleCampaignsReport,
    LoyaltyStoreReport,
    ChallengeCampaignsReport,
    SpinningWheelReport,
    Ocr,
    StockMovements,
    ReorderPopupResponses,
    Wallet,
    ReportRequest,
    SalesPaymentMethod,
    SalesProducts,
    SalesProductsTrend,
    SalesTrend,
    TopProducts,
    TopCategories,
    OrderFrom,
    ProductsAndOptionsReport,
    OperatorSales,
    WaiterTipsReport,
    DashboardReport,
    Storno,
    MasterReport,
    FiscalZReport,
    TableOpenOrderReport,
    PosOrderActionsReport,
    CustomerLifetimeValue,
    ReferralProgramReport,
    PreordersItems,
    MixedReport,
    CharismaReport,
    CharismaLocationReceipt,
    NexusReport,
    LabelEvolution
    // JsonExcel
  },
  data () {
    return {
      comapnyId: null,
      hasCharismaLocation: false,
      hasNexusLocation: false,
      selectedTab: 'Description',
      isSalesPaymentMethod: true,
      isSalesProducts: false,
      isSalesProductsTrend: false,
      isSalesTrend: false,
      isTopProducts: false,
      isTopCategories: false,
      isOrderFrom: false,
      isProductsAndOptions: false,
      isStorno: false,
      isOperatorSales: false,
      isWaiterTips: false,
      isDashboardReport: false,
      isMasterReport: false,
      isMasterReportBeta: false,
      isFiscalZReport: false,
      isCustomerLifetimeValueReport: false,
      isReferralProgramReport: false,
      isTrends: false,
      isReports: false,
      isSalesReportBeta: false,
      isClients: false,
      isProductSales: false,
      isOrderStatus: false,
      isPdfRaport: false,
      isLoyaltyPoints: false,
      isClientPoints: false,
      isDonationReport: false,
      isDonationCampaignsReport: false,
      isRaffleCampaignsReport: false,
      isLoyaltyStoreReport: false,
      isChallengeCampaignsReport: false,
      isSpinningWheelReport: false,
      isOCR: false,
      isStockMovements: false,
      isReorderPopupResponses: false,
      isWallet: false,
      isReportRequest: false,
      isCharismaReport: false,
      isCharismaLocationReceiptReport: false,
      isTableOpenOrderReport: false,
      isPosOrderActionsReport: false,
      isPreordersItems: false,
      isNexusReport: false,
      isLabelEvolution: false,
      isExportableReports: false,
      isMixedReport: false
    }
  },
  created () {
    this.comapnyId = this.$session.get('selectedCompany')
    this.ensureCompanyLocationFlags((sessionData) => {
      this.hasCharismaLocation = !!sessionData.has_charisma_location
      this.hasNexusLocation = !!sessionData.has_nexus_location
    })
    const tab = this.$route.query && this.$route.query.tab
    if (tab === 'charisma') {
      this.selectedTab = this.$t('reports.charismaReport')
      this.isCharismaReport = true
    } else if (tab === 'charisma-location-receipt') {
      this.selectedTab = this.$t('reports.charismaLocationReceipt')
      this.isCharismaLocationReceiptReport = true
    } else if (tab === 'nexus') {
      this.selectedTab = this.$t('reports.nexusReport')
      this.isNexusReport = true
    } else if (tab === 'donation-campaigns-report') {
      this.selectedTab = this.$t('reports.donationCampaignsReport')
      this.isDonationCampaignsReport = true
    } else if (tab === 'raffle-campaigns-report') {
      this.selectedTab = this.$t('reports.raffleCampaignsReport')
      this.isRaffleCampaignsReport = true
    } else if (tab === 'challenge-campaigns-report') {
      this.selectedTab = this.$t('reports.challengeCampaignsReport')
      this.isChallengeCampaignsReport = true
    } else if (tab === 'spinning-wheel-report') {
      this.selectedTab = this.$t('reports.spinningWheelReport')
      this.isSpinningWheelReport = true
    } else if (tab === 'pos-order-actions') {
      this.selectedTab = this.$t('reports.posOrderActionsReport')
      this.isPosOrderActionsReport = true
    }
  },
  methods: {
    showReportRequests () {
      this.isReportRequest = true
      this.selectedTab = this.$t('reports.reportRequestTab')
      this.$nextTick(() => {
        if (this.$refs.reportRequest) this.$refs.reportRequest.getData()
      })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      this.selectedTab = newTab.title
      switch (newTab.title) {
        case 'Export CSV':
          this.isExportableReports = true
          break
        case this.$t('reports.salesReport'):
          this.isReports = true
          break
        case this.$t('reports.salesReportBeta'):
          this.isSalesReportBeta = true
          break
        case this.$t('reports.clients'):
          this.isClients = true
          break
        case this.$t('reports.productsSalesReport'):
          this.isProductSales = true
          break
        case this.$t('reports.orderStatus'):
          this.isOrderStatus = true
          break
        case this.$t('reports.pdfRaport'):
          this.isPdfRaport = true
          break
        case this.$t('reports.loyaltyPoints'):
          this.isLoyaltyPoints = true
          break
        case this.$t('reports.isClientPoints'):
          this.isClientPoints = true
          break
        case this.$t('reports.donationReport'):
          this.isDonationReport = true
          break
        case this.$t('reports.donationCampaignsReport'):
          this.isDonationCampaignsReport = true
          break
        case this.$t('reports.loyaltyStoreReport'):
          this.isLoyaltyStoreReport = true
          break
        case this.$t('reports.challengeCampaignsReport'):
          this.isChallengeCampaignsReport = true
          break
        case this.$t('reports.spinningWheelReport'):
          this.isSpinningWheelReport = true
          break
        case this.$t('reports.ocr'):
          this.isOCR = true
          break
        case this.$t('reports.stockMovements'):
          this.isStockMovements = true
          break
        case this.$t('reports.reorderPopupResponses'):
          this.isReorderPopupResponses = true
          break
        case this.$t('reports.wallet'):
          this.isWallet = true
          break
        case this.$t('reports.reportRequestTab'):
          this.isReportRequest = true
          this.$nextTick(() => {
            if (this.$refs.reportRequest) this.$refs.reportRequest.getData()
          })
          break
        case this.$t('reports.charismaReport'):
          this.isCharismaReport = true
          break
        case this.$t('reports.charismaLocationReceipt'):
          this.isCharismaLocationReceiptReport = true
          break
        case this.$t('reports.nexusReport'):
          this.isNexusReport = true
          break
        case this.$t('reports.paymentType'):
          this.isSalesPaymentMethod = true
          break
        case this.$t('reports.productsSalesReport2'):
          this.isSalesProducts = true
          break
        case this.$t('reports.productSaleTrendsReport'):
          this.isSalesProductsTrend = true
          break
        case this.$t('reports.salesTrendsReport'):
          this.isSalesTrend = true
          break
        case this.$t('reports.topProductsReport'):
          this.isTopProducts = true
          break
        case this.$t('reports.topCategoriesReport'):
          this.isTopCategories = true
          break
        case this.$t('reports.orderFromReport'):
          this.isOrderFrom = true
          break
        case this.$t('reports.productsAndOptionsReport'):
          this.isProductsAndOptions = true
          break
        case this.$t('reports.stornoReport'):
          this.isStorno = true
          break
        case this.$t('reports.operatorSalesReport'):
          this.isOperatorSales = true
          break
        case this.$t('reports.waiterTipsReport'):
          this.isWaiterTips = true
          break
        case this.$t('reports.dashboardReport'):
          this.isDashboardReport = true
          break
        case this.$t('reports.masterReport'):
          this.isMasterReport = true
          break
        case this.$t('reports.masterReportBeta'):
          this.isMasterReportBeta = true
          break
        case this.$t('reports.fiscalZReport'):
          this.isFiscalZReport = true
          break
        case this.$t('reports.tableOpenOrders'):
          this.isTableOpenOrderReport = true
          break
        case this.$t('reports.posOrderActionsReport'):
          this.isPosOrderActionsReport = true
          break
        case this.$t('reports.customerLifetimeValueReport'):
          this.isCustomerLifetimeValueReport = true
          break
        case this.$t('reports.referralProgramReport'):
          this.isReferralProgramReport = true
          break
        case this.$t('reports.raffleCampaignsReport'):
          this.isRaffleCampaignsReport = true
          break
        case this.$t('reports.preordersItems'):
          this.isPreordersItems = true
          break
        case this.$t('reports.mixReport'):
          this.isMixedReport = true
          break
        case this.$t('reports.labelEvolution'):
          this.isLabelEvolution = true
          break
        default:
          this.isTrends = true
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Reports.vue